import { USER } from "constants/AuthConstant";
import axiosHttp from "services/axiosHttp";
import PermissionManager from "utils/class/PermissionManager";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchTargetsList = createAsyncThunk("fetchTargetsList", async ({ page, limit }) => {
	const user_channel = PermissionManager.getItem(USER)?.user?.user_channel[0]?.channel_uuid;
	const params = new URLSearchParams({
		page,
		limit,
	});

	const response = await axiosHttp.get(`channel/${user_channel}/targets?${params}`);
	return response.data.data;
});

const TargetsListSlice = createSlice({
	name: "UserTypeSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchTargetsList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchTargetsList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.page || 1;
			state.total = action.payload.total || 0;
		});
		builder.addCase(fetchTargetsList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default TargetsListSlice.reducer;
